import { Link } from 'react-router-dom';
import { spacer, fontSize, fontWeight, media, colors } from 'settings/style';
import styled, { createGlobalStyle } from 'styled-components';

export const CATEGORY_TREE_SELECT_POPUP_CLASS = 'category-tree-select-popup';

interface ListItemProp {
  bgColor?: 'primary' | 'accent100';
}

export const StyledWrapper = styled(Link) <ListItemProp>`
  padding: ${spacer.lg};
  position: relative;
  border-radius: 12px;
  color: ${colors.grey900};
  text-align: left;
  width: 90%;
`;

/** Full-width wrapper for search + filters above a list (events, posts, groups). */
export const SearchToolbarWrapper = styled.div`
  width: 100%;
  padding: 0 0 0.25rem;
`;

/** Outer shell: full-width toolbar row above content. */
export const SearchToolbarShell = styled.div`
  width: 100%;
  flex: none;
  background: transparent;
  padding: 0 0 1.25rem;
  border-right: none;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
`;

/** Desktop: search left, category aligned to the right; mobile: stacked full width. */
export const SearchFilterRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  width: 100%;
  flex-wrap: nowrap;
  justify-content: flex-start;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }
`;

/** Search + button: capped width so the bar does not stretch across the full row. */
export const ToolbarSearchSlot = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;

  @media (min-width: 768px) {
    flex: 0 1 auto;
    max-width: min(100%, 620px);
  }
`;

export const FilterToolbarWrapper = styled.div`
  flex: 0 1 auto;
  min-width: min(100%, 320px);
  max-width: min(100%, 320px);

  @media (min-width: 768px) {
    margin-left: auto;
  }

  @media (max-width: 767px) {
    width: 100%;
    max-width: none;
    margin-left: 0;
    flex: 1 1 auto;
  }

  .ant-select .ant-select-selector {
    border-radius: 999px !important;
    border: 1px solid #e4e7ec !important;
    min-height: 46px !important;
    align-items: center;
    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  }

  .ant-select:hover .ant-select-selector,
  .ant-select-focused .ant-select-selector {
    border-color: #667085 !important;
  }

  .anticon {
    margin-right: 10px;
    color: #667085;
  }
`;

export const StlyedText = styled.span`
  display: inline-flex;
  margin-left: 85px;
  font-size: ${fontSize.md};
  font-weight: ${fontWeight.light};
  ${media.lg`
    margin-left: 60px;
  `}
`;

export const CategoryTreeLabel = styled.span`
  line-height: 1.3;

  .title {
    font-weight: ${fontWeight.bold};
    color: ${colors.grey900};
  }

  .gloss {
    font-weight: ${fontWeight.normal};
    color: #6d665d;
  }
`;

export const FilterByCheckboxWrapper = styled.div`
  .category-tree-select .ant-select-selector {
    border-radius: 10px !important;
    min-height: 40px !important;
  }

  .category-tree-select .ant-select-selection-item .title {
    font-weight: ${fontWeight.bold};
  }

  .category-tree-select .ant-select-selection-item .gloss {
    font-weight: ${fontWeight.normal};
    color: #6d665d;
  }
`;

/** TreeSelect dropdown is portaled to document.body */
export const CategoryTreeSelectGlobalStyle = createGlobalStyle`
  .${CATEGORY_TREE_SELECT_POPUP_CLASS} .category-tree-label .title {
    font-weight: ${fontWeight.bold};
    color: ${colors.grey900};
  }

  .${CATEGORY_TREE_SELECT_POPUP_CLASS} .category-tree-label .gloss {
    font-weight: ${fontWeight.normal};
    color: #6d665d;
  }
`;
